import { useState } from 'react'
import { Box, Button,TableCell, TableRow, useTheme } from '@mui/material'
import { Item } from '../../../../common/snippets'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import {calculateDynamicFormatLandscape, calculateDynamicFormatPortrait, calculateTotalTableWidth, excelHeaderDetailed} from '../constant'
import { focusElemnt, navigation3 } from '../../../../common/helper'
import jsPDF from 'jspdf'
import { callAddFontRobotoBold } from '../../../../common/font/Roboto-bold'
import { callAddFontRobotoMedium } from '../../../../common/font/Roboto-Medium-normal'
import moment from 'moment'
import autoTable from 'jspdf-autotable'
import AppsIcon from '@mui/icons-material/Apps'
import VirtualizedTable from '../../../../common/virtualisedTable'
import { divideInNIntegers } from '../../../../common/mathHelper'
import { exportToExcel } from '../../../../common/hook'
import { makeTable } from '../../analysisReport/pdfAutotable'
const DeliveryReportDetailed = (props) => {
  const {loginData, toDate, fromDate, tableData, sourceCity, sourceBranch, sourceBranchUser, paymentMode, paymentType, selReportView, updateModal, columnSummaryDefs, selectedFields} = props
  const [state, setState] = useState({
    filter: false,
    generatePDF: false,
    load: false,
    buttonsShow: false,
  })
  const theme = useTheme()
  const { tableHeaderColor } = theme
  const reportName='Delivery Report'
  const currentDateTime = moment(window.getTime ? window.getTime() : new Date()).format('DD-MMM-YYYY HH:mm');
  const {generatePDF, load } = { ...state }
  const filterData = {
    City: sourceCity?.SourceCityName,
    Branch: sourceBranch?.SourceBranchName,
    User: sourceBranchUser?.UserName,
    PayMode: paymentMode?.Name,
    PayType: paymentType?.Name,
    ReportView: selReportView?.ReportView
  }
  const [isPdfLoading, setIsPdfLoading] = useState(true)
  const headers = columnSummaryDefs.map((item) => {
    return {
      header: item.header,
      field: item.field,
      headerSx: item.headerSx,
      exportHead: item.exportHead,
      textAlign: item.headerSx?.textAlign || 'left',
    }
  })
  const excelHeaders = headers.flatMap((col) => {
    if (typeof col.field === 'string' && col.field.includes('^^')) {
      const [field1, field2] = col.field.split('^^')
      const [header1, header2] = (col.exportHead || '').split('\n')
      return [
        { field: field1, header: header1, align: col.textAlign },
        { field: field2, header: header2, align: col.textAlign },
      ]
    }
    return { field: col.field, header: col.exportHead, align: col.textAlign }
  })
  const lengths = divideInNIntegers(excelHeaders.length, 3)
  let index = 0
  const pickedHeaders = []
  lengths.forEach((span) => {
    pickedHeaders.push(excelHeaders[index].field)
    index += span
  })
  const excelData = tableData.map((row) => {
    if (row.dataType === 'subHeader') {
      const colSpan = row.colSpan
      const orderedKeys = headers
        .map((c) => c.field)
        .filter((key) => key in colSpan)
        .map((key) => row[key])
      return {
        ...row,
        ...Object.fromEntries(pickedHeaders.map((key, i) => [key, orderedKeys[i]])),
        colSpan: Object.fromEntries(pickedHeaders.map((key, i) => [key, lengths[i] || 1])),
      }
    }
    if (row.dataType === 'total') {
      return {
        ...row,
        colSpan: { [pickedHeaders[0]]: excelHeaders.findIndex((header) => header.field === 'Unit') },
      }
    }
    return row
  })
  const header1 = [
      [{ header: `Report For: ${reportName}`, field: '', span: excelHeaderDetailed.length ,mainHeader:true}],
    ]
  const printClick = (isSave) => {
    setIsPdfLoading(false)
    setState({ ...state, load: true, generatePDF: true })
    jsPDF.API.events.push(["addFonts", callAddFontRobotoBold]);
    jsPDF.API.events.push(["addFonts", callAddFontRobotoMedium]);
    const widthCell = calculateTotalTableWidth(columnSummaryDefs)
    const header = Object.keys(selectedFields)
    const HeaderColumns = excelHeaderDetailed.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })
    const pdfColumns = columnSummaryDefs.map((col) => {
      if (header.includes(col.field)) {
        return { header: col.header, dataKey: col.field, xlCol: col.xlCol };
      }
      return null;
    }).filter((col) => col !== null);
    const HeaderData = [
      {
        City: sourceCity?.SourceCityName,
        Branch: sourceBranch?.SourceBranchName,
        User: sourceBranchUser?.UserName,
        PayMode: paymentMode?.Name,
        PayType: paymentType?.Name,
        ReportView: selReportView?.ReportView
      },
    ]
    const doc = new jsPDF({ orientation: columnSummaryDefs.length > 12 ? 'l' : 'p', format: columnSummaryDefs.length > 12 ? calculateDynamicFormatLandscape((widthCell > 1400 ? widthCell : 1400) + 60) : calculateDynamicFormatPortrait((widthCell > 793 ? widthCell : 793) + 60), unit: 'px', compress: true })
    var pageSize = doc.internal.pageSize
    // var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
    var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()
    var scaleFactor = pageWidth / (columnSummaryDefs.length > 12 ? 1122 : 793);

    var totalPagesExp = '{total_pages_count_string}'
    const jsPdfHeaderFooter = (data, userData, totalPagesExp) => {
      const doc = data.doc
      // Footer
      var pageSize = doc.internal.pageSize
      var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
      var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()

      var str = 'Page : ' + doc.internal.getNumberOfPages()
      if (typeof doc.putTotalPages === 'function') {
        str = str + ' of ' + totalPagesExp
      }
      doc.setFontSize(scaleFactor * 14)
      doc.text(str, doc.internal.pageSize.width - data.settings.margin.left + 130, pageHeight - 5, "right")
      doc.setFont('Roboto', 'bold')
      doc.text(`Report By : ${userData.strUserName} [ ${userData.strBranchName} ]`, 30, pageHeight - 5)
      doc.text(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`, (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`) * doc.internal.getFontSize() / 2) + 90, pageHeight - 5)
    }

    doc.setProperties({
      title: `${reportName}.pdf`,
      subject: reportName,
      author: 'Maven Tech Labs Pvt. Ltd.',
      keywords: 'maven tech, Cargo system, Receive',
      creator: 'MTLPL',
    })

    autoTable(doc, {
      margin: { top: 60, left: 30, right: 30, bottom: 5 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      columns: HeaderColumns,
      body: HeaderData,
      columnStyles: {
        0: { fontSize: scaleFactor * 14, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
        1: { fontSize: scaleFactor * 14, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
        2: { fontSize: scaleFactor * 14, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
        3: { fontSize: scaleFactor * 14, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
        4: { fontSize: scaleFactor * 14, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
        5: { fontSize: scaleFactor * 14, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
      },
      theme: 'grid',
      startY: 160,
      headStyles: {
        fillColor: [191, 225, 255],
        textColor: [0, 0, 0],
        minCellHeight: 36,
        valign: 'middle',
        cellPadding: 12,
        fontSize: scaleFactor * 14,
        font: 'Roboto',
        fontStyle: 'normal',
        lineWidth: 0.6,
      },
      didDrawPage: function (data) {
        doc.setTextColor(scaleFactor * 40)
        doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
        doc.setFontSize(scaleFactor * 20).setFont("Roboto", 'bold')
        doc.setTextColor(16, 79, 162)
        doc.text(`Cargo System | ${reportName}`, 30 + 60, 80)
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(scaleFactor * 20).setFont("Roboto", 'bold')
        doc.text(`Company Name :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, "right")
         doc.setTextColor(0, 0, 0)
        doc.setFontSize(scaleFactor * 16).setFont('Roboto', 'bold')
        doc.text(`Delivery Date: ${moment(fromDate).format("DD-MMM-YYYY")} To ${moment(toDate).format("DD-MMM-YYYY")} `, data.settings.margin.left, 150)
        doc.text(`Report: Own Deliveries`, doc.internal.pageSize.width - data.settings.margin.left, 150, "right")
        jsPdfHeaderFooter(data, loginData, totalPagesExp)
      },
    })
    makeTable(doc, autoTable, pdfColumns, tableData, 1, 'Own Delivery', loginData, 'everyPage', () => {}, 120, false)
    doc.setFont('Roboto')

    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp)
    }
    if (isSave) {
      doc.save(`Delivery Detailed Report ${currentDateTime}.pdf`)
      setTimeout(() => {
        setState({ ...state, generatePDF: false, load: true })
        const pdfUrl = doc.output('bloburl')
        document.getElementById('deliveryDetailedReportoutput').data = pdfUrl
        // document.getElementById('deliveryDetailedReportoutput').data = doc.output('datauristring', 'DeliveryDetailedReport..pdf')
        focusElemnt('deliveryBackBtn')
      }, 2000)
    } else {
      setTimeout(() => {
        setState({ ...state, generatePDF: false, load: true })
        const pdfUrl = doc.output('bloburl')
        document.getElementById('deliveryDetailedReportoutput').data = pdfUrl
        // document.getElementById('deliveryDetailedReportoutput').data = doc.output('datauristring', 'DeliveryDetailedReport..pdf')
        focusElemnt('deliveryBackBtn')
      }, 2000)
    }

  }
  const headerContent = () => {
    return (
      <>
        <TableRow>
          <TableCell
            className="reportTD"
            style={{
              fontWeight: 'bold',
              fontSize: '12px',
              lineheight: '16px',
              letterspacing: '0.24px',
              fontWeight: '500',
              textAlign: 'left',
              color: '#444444',
              backgroundColor: '#bfe1ff',
              position: 'sticky',
              top: '0px',
              height: '36px',
              padding: '10px 4px',
            }}
            colSpan={headers.length}
          >
            {reportName}
          </TableCell>
        </TableRow>
        <TableRow style={{ height: '47px' }}>
          {headers.map((item) => {
            return (
              <TableCell
                style={{
                  ...item?.headerSx,
                  backgroundColor: '#e5f3ff',
                  color: '#444',
                  fontSize: '12px',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  fontWeight: '600',
                  whiteSpace: 'pre-line',
                  padding: '10px 4px',
                }}
                colSpan={1}
              >
                {item?.header}
              </TableCell>
            )
          })}
        </TableRow>
      </>
    )
  }
  const DeliveryBody = ({ row, index, tableHeaderColor, columnDefs }) => {
    if (!row?.dataType) return null
    const getStyles = (field, align) => {
      const common = {
        minHeight: '36px',
        fontSize: '12px',
        color: '#444',
        padding: '10px 4px',
        whiteSpace: 'pre',
      }
      if (row.dataType === 'entry') {
        return {
          ...common,
          fontWeight: '500',
          textAlign: align || 'left',
          height: '36px',
        }
      }
      if (row.dataType === 'subHeader') {
        return {
          ...common,
          fontWeight: '600',
          backgroundColor: tableHeaderColor?.isSubHeadingColor,
          textAlign: row.align?.[field] || 'left',
        }
      }
      if (row.dataType === 'total') {
        return {
          ...common,
          fontWeight: '600',
          backgroundColor: tableHeaderColor?.isTotalColor,
          textAlign: row.align?.[field] || 'right',
        }
      }
    }

    return (
      <>
        {(() => {
          let skip = 0

          return columnDefs.map((item, i) => {
            if (skip > 0) {
              skip--
              return null
            }
            const colSpan = row.colSpan?.[item.field] || 1
            skip = colSpan - 1
            return (
              <TableCell className="reportTD" key={item.field + i + index} colSpan={colSpan} style={getStyles(item.field, item.textAlign)}>
                {row[item.field]}
              </TableCell>
            )
          })
        })()}
      </>
    )
  }
  const bodyContent = (index, obj) => {
    return <DeliveryBody row={obj} index={index} tableHeaderColor={tableHeaderColor} columnDefs={headers} />
  }
  return (
    <>
      <Box sx={{ ...sx.reportFlex, padding: "0px 16px !important", justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
        <Box
          style={{ display: 'flex', width: '50%', justifyContent: 'flex-start', alignItems: 'center', gap: '12px', fontSize: '14px' }}
        >
          <h2 style={{ color: '#444' }}>Report For: {reportName}</h2>
          <Box style={{ height: '32px', display: 'flex', padding: '8px 12px', justifycontent: 'center', alignitems: 'center', gap: '6px', }}
            id="dispatchReportManageColumn"
            tabIndex={0}
            onClick={() => updateModal(true, 'ownDeliveryShowManageColumn')}
          >
            <span tabIndex={0} style={{ display: 'flex', margin: '-3px' }}>
              <AppsIcon />
            </span>
            <span tabIndex={0} style={{ fontWeight: 'bold' }}>
              MANAGE COLUMNS
            </span>
          </Box>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'end', flexWrap: 'wrap', gap: '10px', alignItems: 'center' }} className="itemButtons">
          {isPdfLoading ? (
            <>
              <Item sx={sx.itemsx} className="disabled-wrapper" onKeyDown={(e) => navigation3(e, 'exportAsPdfBtn', 'DeliverySplitBtn', () => { })}>
                <Button
                  variant="outlined"
                  sx={{ width: '100%' }}
                  className="receiveitembtn"
                  onClick={(e) => {
                    e.preventDefault()
                    exportToExcel({
                      fileName: `${reportName} ${currentDateTime}.xlsx`,
                      sheetName: 'Delivery',
                      headersList: [header1, excelHeaderDetailed, excelHeaders],
                      dataList: [[], [filterData], excelData],
                    })
                  }}
                >
                  Export to Excel
                </Button>
              </Item>
              <Item sx={sx.itemsx} className="disabled-wrapper">
                <Button
                  id="exportAsPdfBtn"
                  variant="outlined"
                  sx={{ width: '100%' }}
                  className="receiveitembtn"
                  onKeyDown={(e) => navigation3(e, 'PrintBtn', 'ExpToExlbtn', () => { })}
                  onClick={() => { setIsPdfLoading(false); printClick(true) }}
                >
                  Export As PDF
                </Button>
              </Item>
              <Item sx={sx.itemsx} className="disabled-wrapper">
                <Button
                  variant="outlined"
                  sx={{ width: '100%' }}
                  className="receiveitembtn"
                  id="PrintBtn"
                  onKeyDown={(e) => navigation3(e, 'fromDate', 'exportAsPdfBtn', () => { })}
                  onClick={() => { setIsPdfLoading(false); printClick(false) }}
                >
                  Print
                </Button>
              </Item>
            </>
          ) : (
            <Item sx={sx.itemsx} className="disabled-wrapper">
              <Button id='deliveryBackBtn' variant="outlined" sx={{ width: '100%' }} className="receiveitembtn"
                onClick={() => setIsPdfLoading(true)}
                onKeyDown={(e) => navigation3(e, 'deliveryBackBtn', 'deliveryBackBtn', () => { setIsPdfLoading(true); focusElemnt('DeliverySplitBtn') })}
              >
                Back
              </Button>
            </Item>
          )}
        </Box>
      </Box>
      {isPdfLoading ? (
        <>
          <VirtualizedTable
            tableData={tableData}
            headerContent={headerContent}
            rowContent={bodyContent}
            tableStyle={{ tableLayout: 'auto', width: '100%' }}
            autoResize={true}
          />
        </>
      ) : (
        <>
          {generatePDF ? <div className={'generatePDF'}>Generating PDF....</div> : ''}
          {load ? (
            <object
              id="deliveryDetailedReportoutput"
              type="application/pdf"
              width="100%"
              height="440"
              title="MTLPL -Cargo System - DeliveryDetailed Report"
              aria-label="MTLPL -Cargo System - DeliveryDetailed  Report"
            ></object>
          ) : (
            ''
          )}
        </>
      )}
    </>
  )
}

export default DeliveryReportDetailed